// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap'); */

:root {
  /* Paleta SEJUS */
  --azul: #034ea2;
  --amarelo: #fdb913;
  --Vermelho: #ef4123;
  --verde: #007932;
  --fundo2: #C4D6FF;

  /* Outras cores */
  --branco: #ffffff;
  --vermelho2: #FED6CD;
  --azul2: #09478e;
  --amarelo2: #F6B419;
  --amarelo3: #FFF4DE;
  --verde2: #16c098b3;
  --texto: #292D32;
  --texto2: #B0BBD5;
  --texto-destaque: #265DAF;
  --borda: #DFE5EE;
  --fundo: #F4F7FE;
  --fundo-input: #e4e9f74a;
  /* 
#C4D6FF
#265DAF
 */
  --preto: #000000;
  --azul-escuro: #11101d;
  --azul-escuro2: #1d1b31;

  /* Tokens de UI (base para novo visual) */
  --ui-bg: var(--fundo);
  --ui-surface: var(--branco);
  --ui-primary: var(--azul);
  --ui-primary-contrast: var(--branco);
  --ui-text: var(--texto);
  --ui-muted: #7a8699;
  --ui-border: var(--borda);
  --ui-input-bg: #f7f9ff;
  --ui-radius-lg: 16px;
  --ui-radius-md: 12px;
  --ui-radius-sm: 8px;
  --ui-shadow-sm: 0 2px 8px rgba(16, 24, 40, 0.06);
  --ui-shadow-md: 0 6px 18px rgba(16, 24, 40, 0.08);
}


body {
  /* font-family: 'Montserrat'; */
  font-family: 'Plus Jakarta Sans';
  font-weight: 400;
  letter-spacing: .8px;
  color: var(--ui-text);
}

h1,
h2,
h3 {
  font-weight: 700;
  color: var(--ui-text);
  margin: 8px 0 16px;
}

h4 {
  font-weight: 700;
  color: var(--ui-primary);
  margin: 6px 0 12px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  position: relative;
  background: var(--fundo);
  min-height: 100vh;
  top: 72px;
  left: 78px;
  width: calc(100% - 78px);
  transition: all 0.5s ease;
  padding: 20px;
}


.content {
  background-color: var(--ui-surface);
  padding: 16px;
  border-radius: var(--ui-radius-lg);
  border: 1px solid var(--ui-border);
  box-shadow: var(--ui-shadow-sm);
  min-height: auto !important;
}

/* Card utilitário global */
.ui-card {
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  box-shadow: var(--ui-shadow-sm);
  padding: 16px;
}

li {
  list-style: none;
}

a {
  text-decoration: none;
}


/* Classe do p de não a dados a ser mostrados */
.semDados {
  text-align: center;
  color: #888;
  font-style: italic;
}

/* Estilo para tabela */
.content-table {
  overflow-x: auto;
  min-height: 300px !important;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  padding: 8px 12px;
  box-shadow: var(--ui-shadow-sm);
}

table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  /* overflow: hidden; */
}

th,
td {
  border-bottom: 1px solid var(--ui-border);
  padding: 14px 12px;
  white-space: nowrap;
  box-sizing: border-box;
  text-align: left;

}

th {
  color: var(--ui-primary);
  font-weight: 600;
  text-transform: uppercase;
  font-size: 12px;
}

td {
  border-bottom: 1px solid var(--ui-border);
  white-space: nowrap;
  font-size: 14px;
}

tr:hover {
  background-color: #f5f8ff;
}

.td-table-icon {
  width: 100px;
  display: flex;
  justify-content: space-evenly;
}


.td-table-icon a i {
  color: var(--texto);
  font-weight: 800;
}

.td-limited {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

.content-table button {
  padding: 0;
  background: none;
  color: var(--azul);
  border: none;
}

table button {
  border: none;

}

button {
  background-color: transparent;
  color: var(--ui-primary);
  border-radius: var(--ui-radius-md);
  font-weight: 700;
  padding: 8px 18px;
  border: 1px solid var(--ui-primary);
  max-height: 40px;
  opacity: .8;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

button:hover {
  opacity: 1;
  transform: translateY(-1px);
}

button:disabled,
button[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-disabled {
  cursor: not-allowed !important;
  opacity: 0.7;
  pointer-events: none;
}

.enviar-button-container {
  width: 100%;
  display: flex;
  justify-content: end;
  padding: 20px;
}


.active {
  background-color: var(--branco);
  color: var(--texto);
}

.h4-title {
  position: relative;
  margin-bottom: 20px;
  padding: 8px 0;
  color: var(--ui-primary);
  font-weight: 700;
}

.h4-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 72px;
  height: 2px;
  border-radius: 99px;
  background-color: rgba(3, 78, 162, 0.2);
}

/* Estilo para a lista de paginação */
.pagination-options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.pagination-options  > div {
    display: flex;
    flex-direction: column;
  }
:is(.pagination-options > div)  > label {
      font-size: 12px;
      margin-left: 5px;
      color: var(--ui-muted);
    }
:is(.pagination-options > div)  > select {
      padding: 6px 10px;
    }

.pagination {
  list-style: none;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 0;
  gap: 4px;
}

.page {
  margin: 0 2px;
  font-size: 12px;
  cursor: pointer;
  color: var(--ui-text);
  padding: 4px 8px;
  border-radius: 8px;
  border: 1px solid transparent;
}

.activeNumber {
  background-color: rgba(3, 78, 162, 0.12);
  color: var(--ui-primary);
  border-color: rgba(3, 78, 162, 0.2);
}

.prev,
.next {
  margin: 0 10px;
  font-size: 18px;
  cursor: pointer;
  color: var(--ui-primary);
  transition: .4s;
}

.prev:hover,
.next:hover {
  color: var(--azul);
}

/* Estilo para formularios */
form,
.div-form-container {
  max-width: 100%;
  margin: 20px auto;
  padding: 0 20px;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.form-group-large {
  width: 100%;
  margin-bottom: 30px;
}

.form-group {
  flex-basis: calc(50% - 15px);
  margin-bottom: 20px;
}

.form-group-duplo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-group-triplo {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 10px;
  margin-bottom: 20px;
}

label {
  display: block;
  font-size: 16px;
  margin-bottom: 5px;
  color: var(--ui-text);
  font-weight: 600;
}

input[type="text"],
input[type="url"],
input[type="file"],
input[type="tel"],
input[type="date"],
input[type="time"],
input[type="datetime-local"],
input[type="email"],
input[type="number"],
input[type="password"],
select,
textarea {
  width: 100%;
  padding: 12px 14px;
  font-size: 15px;
  background-color: var(--ui-input-bg);
  color: var(--ui-text);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  transition: border-color .2s ease, box-shadow .2s ease;
}

input[type="text"]:focus,
input[type="file"]:focus,
input[type="tel"]:focus,
input[type="email"]:focus,
input[type="number"]:focus,
input[type="password"]:focus,
input[type="date"]:focus,
select:focus,
textarea:focus {
  background-color: var(--ui-input-bg);
  outline: none;
  color: var(--ui-text);
  border-color: rgba(3, 78, 162, 0.4);
  box-shadow: 0 0 0 3px rgba(3, 78, 162, 0.08);
}

input[type="checkbox"],
input[type="radio"] {
  margin-right: 5px;
  width: 15px;
  height: 15px;
}

.checkbox-container {
  width: 100%;
  margin-bottom: 10px;
}

.checkbox-group2 {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
}

.checkbox-group2 label {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-sm);
  font-size: 14px;
  width: 280px;
  white-space: normal;
  word-break: break-word;
  background: var(--ui-input-bg);
}

.checkbox-group {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 10px;
  margin-bottom: 20px;
  box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.1);
}

.checkbox-group>div {
  width: 200px;
}

.checkbox-group label {
  white-space: nowrap;
}

.checkbox-group input[type="checkbox"] {
  display: none;
}

.checkbox-group input[type="checkbox"]+label {
  display: inline-block;
  padding-left: 25px;
  position: relative;
  cursor: pointer;
}

.checkbox-group input[type="checkbox"]+label:before {
  content: '';
  position: absolute;
  left: 0;
  top: 2px;
  width: 10px;
  height: 10px;
  border: 2px solid var(--azul-escuro);
  border-radius: 3px;
  opacity: .8;
  background-color: transparent;
}

.checkbox-group input[type="checkbox"]:checked+label:before {
  background-color: var(--azul);
  border-color: transparent;
}

.checkbox-container .content-items {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.content-items::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: -50px;
  width: 100%;
  height: 1px;
  background-color: var(--fundo);
}

.checkbox-container .content-items>div {
  width: 100%;
  display: flex;
  gap: 10px;
}

.btnAdcionar {
  background-color: var(--fundo2);
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--texto-destaque);
  font-weight: 500;
  font-size: 16px;
  letter-spacing: .4px;
  opacity: .9;
}

/* Padrão moderno de botões (mapeia classes existentes) */
:is(
  .social-submit-button,
  .btnConfirmar,
  .btn-login,
  .btn-cadastrar-interno,
  .save-btn,
  .btnAcao,
  .add-button,
  .btn-apply,
  .submit-button-moviment,
  .visitante-btn-primary
) {
  background: var(--ui-primary);
  color: #fff;
  border-color: var(--ui-primary);
  box-shadow: 0 6px 14px rgba(37, 99, 235, 0.18);
}

:is(
  .btnAdcionar,
  .btn-reset,
  .btn-edit,
  .btn-visitor-secondary,
  .visitante-btn-secondary,
  .btn-open-quick
) {
  background: #eef3ff;
  color: var(--ui-primary);
  border-color: #cdd9f7;
  box-shadow: none;
}

:is(
  .btn-cancel,
  .cancel-button,
  .remove-button,
  .del-interno-btn,
  .change-cell-remove,
  .btn-cancelar
) {
  background: #ffecec;
  color: #c43c3c;
  border-color: #f2c9c9;
}

:is(
  .btn-actions,
  .btn-agendamento,
  .edit-icon-button
) {
  background: #f7f9fe;
  border-color: #e1e8f6;
  color: #2b3a55;
}

button img,
.btnAdcionar img,
.social-submit-button img {
  width: 18px;
  height: 18px;
  display: inline-block;;
}

.btnAdcionar .i {
  font-size: 20px;
  font-weight: 600;
}

/* .btnAdcionar:hover::after {
  content: "Adicionar Novo";
  position: absolute;
  background-color: #fff;
  color: var(--azul-escuro);
  padding: 5px 10px;
  border-radius: 5px;
  bottom: 20px;
  right: 30px;
  white-space: nowrap;
  font-size: 12px;
  opacity: 1;
  scale: none;
  box-shadow: 0px 0px 6px 1px;
  transition: opacity 0.3s;
} */

.btn-edit {
  padding: 10px !important;
  border-radius: 6px;
  border: 1px solid var(--texto-destaque) !important;
  font-size: 14px;
}

/* Conduta */
.green-text {
  background-color: var(--verde2);
  text-align: center;
  font-size: 14px;
  color: var(--verde);
  border: 1px solid var(--verde);
  padding: 0 6px;
  border-radius: 4px;
}

.blue-text {
  background-color: var(--fundo2);
  text-align: center;
  font-size: 14px;

  color: var(--texto-destaque);
  border: 1px solid var(--texto-destaque);
  padding: 0 6px;
  border-radius: 4px;
}

.red-text {
  text-align: center;
  font-size: 14px;
  background-color: var(--vermelho2);
  color: var(--Vermelho);
  border: 1px solid var(--Vermelho);
  padding: 0 6px;
  border-radius: 4px;
}

.orange-text {
  background-color: var(--amarelo3);
  text-align: center;
  font-size: 14px;
  color: var(--amarelo2);
  border: 1px solid var(--amarelo2);
  padding: 0 6px;
  border-radius: 4px;
}

.purple-text {
  background-color: #f2ecff;
  text-align: center;
  font-size: 14px;
  color: #5a39a8;
  border: 1px solid #7c5cc7;
  padding: 0 6px;
  border-radius: 4px;
}

abbr {
  text-decoration: none;
}


/* Animacao */
/* Keyframes for the enter animation (bottom to top) */
@keyframes slideIn {
  from {
    transform: translateY(100%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Keyframes for the exit animation (top to bottom) */
@keyframes slideOut {
  from {
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform: translateY(-100%);
    opacity: 0;
  }
}

/* Base style for the section */
.container-animation {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

/* Enter animation applied when section is displayed */
.container-animation.show {
  animation: slideIn 0.5s ease forwards;
}

/* Exit animation applied when section is hidden */
.container-animation.hide {
  animation: slideOut 0.5s ease forwards;
}


@media screen and (max-width: 580px) {
  form {
    flex-direction: column;
  }
}
.page-title,
h2.page-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--ui-text);
  margin: 6px 0 14px;
}

.section-title,
.h4-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--ui-primary);
  margin: 6px 0 12px;
}

/* primeiro título da página assume estilo de page-title */
.container h1:first-of-type,
.container h2:first-of-type,
.container h3:first-of-type,
.container h4:first-of-type {
  font-size: 20px;
  font-weight: 700;
  color: var(--ui-text);
  margin: 6px 0 14px;
}

.filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  padding: 12px;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  background: var(--ui-surface);
  box-shadow: var(--ui-shadow-sm);
}

.filter-group {
  display: flex;
  gap: 8px;
  align-items: center;
}

.filter-actions {
  margin-left: auto;
  display: flex;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,qHAAqH;;AAGrH;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;;EAEjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB;;;EAGA;EACA,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;;EAEvB,yCAAyC;EACzC,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,gDAAgD;EAChD,iDAAiD;AACnD;;;AAGA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;;EAGE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;AACf;;;AAGA;EACE,mCAAmC;EACnC,aAAa;EACb,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;EAEE,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;;AAElB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6BAA6B;AAC/B;;;AAGA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;;AAEd;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,wEAAwE;EACxE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,aAAa;AACf;;;AAGA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AAgBX;AAdE;IACE,aAAa;IACb,sBAAsB;EAWxB;AATE;MACE,eAAe;MACf,gBAAgB;MAChB,sBAAsB;IACxB;AAEA;MACE,iBAAiB;IACnB;;AAIJ;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;;EAEE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;EAYE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,qBAAqB;EACrB,kCAAkC;EAClC,kCAAkC;EAClC,sDAAsD;AACxD;;AAEA;;;;;;;;;EASE,oCAAoC;EACpC,aAAa;EACb,qBAAqB;EACrB,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,kCAAkC;EAClC,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA,yDAAyD;AACzD;;;;;;;;;;;;EAYE,6BAA6B;EAC7B,WAAW;EACX,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;;;;;;;;EAQE,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;EAKE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kDAAkD;EAClD,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;;EAEf,4BAA4B;EAC5B,uCAAuC;EACvC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,sBAAsB;EACtB,iCAAiC;EACjC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,iCAAiC;EACjC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA,aAAa;AACb,sDAAsD;AACtD;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,qDAAqD;AACrD;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA,+BAA+B;AAC/B;EACE,kDAAkD;AACpD;;AAEA,sDAAsD;AACtD;EACE,qCAAqC;AACvC;;AAEA,kDAAkD;AAClD;EACE,sCAAsC;AACxC;;;AAGA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,0DAA0D;AAC1D;;;;EAIE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;AACV","sourcesContent":["/* @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap'); */\n@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap');\n\n:root {\n  /* Paleta SEJUS */\n  --azul: #034ea2;\n  --amarelo: #fdb913;\n  --Vermelho: #ef4123;\n  --verde: #007932;\n  --fundo2: #C4D6FF;\n\n  /* Outras cores */\n  --branco: #ffffff;\n  --vermelho2: #FED6CD;\n  --azul2: #09478e;\n  --amarelo2: #F6B419;\n  --amarelo3: #FFF4DE;\n  --verde2: #16c098b3;\n  --texto: #292D32;\n  --texto2: #B0BBD5;\n  --texto-destaque: #265DAF;\n  --borda: #DFE5EE;\n  --fundo: #F4F7FE;\n  --fundo-input: #e4e9f74a;\n  /* \n#C4D6FF\n#265DAF\n */\n  --preto: #000000;\n  --azul-escuro: #11101d;\n  --azul-escuro2: #1d1b31;\n\n  /* Tokens de UI (base para novo visual) */\n  --ui-bg: var(--fundo);\n  --ui-surface: var(--branco);\n  --ui-primary: var(--azul);\n  --ui-primary-contrast: var(--branco);\n  --ui-text: var(--texto);\n  --ui-muted: #7a8699;\n  --ui-border: var(--borda);\n  --ui-input-bg: #f7f9ff;\n  --ui-radius-lg: 16px;\n  --ui-radius-md: 12px;\n  --ui-radius-sm: 8px;\n  --ui-shadow-sm: 0 2px 8px rgba(16, 24, 40, 0.06);\n  --ui-shadow-md: 0 6px 18px rgba(16, 24, 40, 0.08);\n}\n\n\nbody {\n  /* font-family: 'Montserrat'; */\n  font-family: 'Plus Jakarta Sans';\n  font-weight: 400;\n  letter-spacing: .8px;\n  color: var(--ui-text);\n}\n\nh1,\nh2,\nh3 {\n  font-weight: 700;\n  color: var(--ui-text);\n  margin: 8px 0 16px;\n}\n\nh4 {\n  font-weight: 700;\n  color: var(--ui-primary);\n  margin: 6px 0 12px;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.container {\n  position: relative;\n  background: var(--fundo);\n  min-height: 100vh;\n  top: 72px;\n  left: 78px;\n  width: calc(100% - 78px);\n  transition: all 0.5s ease;\n  padding: 20px;\n}\n\n\n.content {\n  background-color: var(--ui-surface);\n  padding: 16px;\n  border-radius: var(--ui-radius-lg);\n  border: 1px solid var(--ui-border);\n  box-shadow: var(--ui-shadow-sm);\n  min-height: auto !important;\n}\n\n/* Card utilitário global */\n.ui-card {\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  box-shadow: var(--ui-shadow-sm);\n  padding: 16px;\n}\n\nli {\n  list-style: none;\n}\n\na {\n  text-decoration: none;\n}\n\n\n/* Classe do p de não a dados a ser mostrados */\n.semDados {\n  text-align: center;\n  color: #888;\n  font-style: italic;\n}\n\n/* Estilo para tabela */\n.content-table {\n  overflow-x: auto;\n  min-height: 300px !important;\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  padding: 8px 12px;\n  box-shadow: var(--ui-shadow-sm);\n}\n\ntable {\n  border-collapse: collapse;\n  width: 100%;\n  margin-bottom: 20px;\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  /* overflow: hidden; */\n}\n\nth,\ntd {\n  border-bottom: 1px solid var(--ui-border);\n  padding: 14px 12px;\n  white-space: nowrap;\n  box-sizing: border-box;\n  text-align: left;\n\n}\n\nth {\n  color: var(--ui-primary);\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 12px;\n}\n\ntd {\n  border-bottom: 1px solid var(--ui-border);\n  white-space: nowrap;\n  font-size: 14px;\n}\n\ntr:hover {\n  background-color: #f5f8ff;\n}\n\n.td-table-icon {\n  width: 100px;\n  display: flex;\n  justify-content: space-evenly;\n}\n\n\n.td-table-icon a i {\n  color: var(--texto);\n  font-weight: 800;\n}\n\n.td-limited {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 180px;\n}\n\n.content-table button {\n  padding: 0;\n  background: none;\n  color: var(--azul);\n  border: none;\n}\n\ntable button {\n  border: none;\n\n}\n\nbutton {\n  background-color: transparent;\n  color: var(--ui-primary);\n  border-radius: var(--ui-radius-md);\n  font-weight: 700;\n  padding: 8px 18px;\n  border: 1px solid var(--ui-primary);\n  max-height: 40px;\n  opacity: .8;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\nbutton:hover {\n  opacity: 1;\n  transform: translateY(-1px);\n}\n\nbutton:disabled,\nbutton[disabled] {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-disabled {\n  cursor: not-allowed !important;\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n.enviar-button-container {\n  width: 100%;\n  display: flex;\n  justify-content: end;\n  padding: 20px;\n}\n\n\n.active {\n  background-color: var(--branco);\n  color: var(--texto);\n}\n\n.h4-title {\n  position: relative;\n  margin-bottom: 20px;\n  padding: 8px 0;\n  color: var(--ui-primary);\n  font-weight: 700;\n}\n\n.h4-title::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 72px;\n  height: 2px;\n  border-radius: 99px;\n  background-color: rgba(3, 78, 162, 0.2);\n}\n\n/* Estilo para a lista de paginação */\n.pagination-options {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n\n  >div {\n    display: flex;\n    flex-direction: column;\n\n    >label {\n      font-size: 12px;\n      margin-left: 5px;\n      color: var(--ui-muted);\n    }\n\n    >select {\n      padding: 6px 10px;\n    }\n  }\n}\n\n.pagination {\n  list-style: none;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 10px 0;\n  gap: 4px;\n}\n\n.page {\n  margin: 0 2px;\n  font-size: 12px;\n  cursor: pointer;\n  color: var(--ui-text);\n  padding: 4px 8px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n}\n\n.activeNumber {\n  background-color: rgba(3, 78, 162, 0.12);\n  color: var(--ui-primary);\n  border-color: rgba(3, 78, 162, 0.2);\n}\n\n.prev,\n.next {\n  margin: 0 10px;\n  font-size: 18px;\n  cursor: pointer;\n  color: var(--ui-primary);\n  transition: .4s;\n}\n\n.prev:hover,\n.next:hover {\n  color: var(--azul);\n}\n\n/* Estilo para formularios */\nform,\n.div-form-container {\n  max-width: 100%;\n  margin: 20px auto;\n  padding: 0 20px;\n  border-radius: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.form-group-large {\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n.form-group {\n  flex-basis: calc(50% - 15px);\n  margin-bottom: 20px;\n}\n\n.form-group-duplo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.form-group-triplo {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\nlabel {\n  display: block;\n  font-size: 16px;\n  margin-bottom: 5px;\n  color: var(--ui-text);\n  font-weight: 600;\n}\n\ninput[type=\"text\"],\ninput[type=\"url\"],\ninput[type=\"file\"],\ninput[type=\"tel\"],\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"email\"],\ninput[type=\"number\"],\ninput[type=\"password\"],\nselect,\ntextarea {\n  width: 100%;\n  padding: 12px 14px;\n  font-size: 15px;\n  background-color: var(--ui-input-bg);\n  color: var(--ui-text);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  transition: border-color .2s ease, box-shadow .2s ease;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"file\"]:focus,\ninput[type=\"tel\"]:focus,\ninput[type=\"email\"]:focus,\ninput[type=\"number\"]:focus,\ninput[type=\"password\"]:focus,\ninput[type=\"date\"]:focus,\nselect:focus,\ntextarea:focus {\n  background-color: var(--ui-input-bg);\n  outline: none;\n  color: var(--ui-text);\n  border-color: rgba(3, 78, 162, 0.4);\n  box-shadow: 0 0 0 3px rgba(3, 78, 162, 0.08);\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  margin-right: 5px;\n  width: 15px;\n  height: 15px;\n}\n\n.checkbox-container {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.checkbox-group2 {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.checkbox-group2 label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-sm);\n  font-size: 14px;\n  width: 280px;\n  white-space: normal;\n  word-break: break-word;\n  background: var(--ui-input-bg);\n}\n\n.checkbox-group {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  padding: 10px;\n  margin-bottom: 20px;\n  box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.1);\n}\n\n.checkbox-group>div {\n  width: 200px;\n}\n\n.checkbox-group label {\n  white-space: nowrap;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  display: none;\n}\n\n.checkbox-group input[type=\"checkbox\"]+label {\n  display: inline-block;\n  padding-left: 25px;\n  position: relative;\n  cursor: pointer;\n}\n\n.checkbox-group input[type=\"checkbox\"]+label:before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 2px;\n  width: 10px;\n  height: 10px;\n  border: 2px solid var(--azul-escuro);\n  border-radius: 3px;\n  opacity: .8;\n  background-color: transparent;\n}\n\n.checkbox-group input[type=\"checkbox\"]:checked+label:before {\n  background-color: var(--azul);\n  border-color: transparent;\n}\n\n.checkbox-container .content-items {\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n  padding-bottom: 10px;\n  margin-bottom: 20px;\n}\n\n.content-items::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: -50px;\n  width: 100%;\n  height: 1px;\n  background-color: var(--fundo);\n}\n\n.checkbox-container .content-items>div {\n  width: 100%;\n  display: flex;\n  gap: 10px;\n}\n\n.btnAdcionar {\n  background-color: var(--fundo2);\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--texto-destaque);\n  font-weight: 500;\n  font-size: 16px;\n  letter-spacing: .4px;\n  opacity: .9;\n}\n\n/* Padrão moderno de botões (mapeia classes existentes) */\n:is(\n  .social-submit-button,\n  .btnConfirmar,\n  .btn-login,\n  .btn-cadastrar-interno,\n  .save-btn,\n  .btnAcao,\n  .add-button,\n  .btn-apply,\n  .submit-button-moviment,\n  .visitante-btn-primary\n) {\n  background: var(--ui-primary);\n  color: #fff;\n  border-color: var(--ui-primary);\n  box-shadow: 0 6px 14px rgba(37, 99, 235, 0.18);\n}\n\n:is(\n  .btnAdcionar,\n  .btn-reset,\n  .btn-edit,\n  .btn-visitor-secondary,\n  .visitante-btn-secondary,\n  .btn-open-quick\n) {\n  background: #eef3ff;\n  color: var(--ui-primary);\n  border-color: #cdd9f7;\n  box-shadow: none;\n}\n\n:is(\n  .btn-cancel,\n  .cancel-button,\n  .remove-button,\n  .del-interno-btn,\n  .change-cell-remove,\n  .btn-cancelar\n) {\n  background: #ffecec;\n  color: #c43c3c;\n  border-color: #f2c9c9;\n}\n\n:is(\n  .btn-actions,\n  .btn-agendamento,\n  .edit-icon-button\n) {\n  background: #f7f9fe;\n  border-color: #e1e8f6;\n  color: #2b3a55;\n}\n\nbutton img,\n.btnAdcionar img,\n.social-submit-button img {\n  width: 18px;\n  height: 18px;\n  display: inline-block;;\n}\n\n.btnAdcionar .i {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n/* .btnAdcionar:hover::after {\n  content: \"Adicionar Novo\";\n  position: absolute;\n  background-color: #fff;\n  color: var(--azul-escuro);\n  padding: 5px 10px;\n  border-radius: 5px;\n  bottom: 20px;\n  right: 30px;\n  white-space: nowrap;\n  font-size: 12px;\n  opacity: 1;\n  scale: none;\n  box-shadow: 0px 0px 6px 1px;\n  transition: opacity 0.3s;\n} */\n\n.btn-edit {\n  padding: 10px !important;\n  border-radius: 6px;\n  border: 1px solid var(--texto-destaque) !important;\n  font-size: 14px;\n}\n\n/* Conduta */\n.green-text {\n  background-color: var(--verde2);\n  text-align: center;\n  font-size: 14px;\n  color: var(--verde);\n  border: 1px solid var(--verde);\n  padding: 0 6px;\n  border-radius: 4px;\n}\n\n.blue-text {\n  background-color: var(--fundo2);\n  text-align: center;\n  font-size: 14px;\n\n  color: var(--texto-destaque);\n  border: 1px solid var(--texto-destaque);\n  padding: 0 6px;\n  border-radius: 4px;\n}\n\n.red-text {\n  text-align: center;\n  font-size: 14px;\n  background-color: var(--vermelho2);\n  color: var(--Vermelho);\n  border: 1px solid var(--Vermelho);\n  padding: 0 6px;\n  border-radius: 4px;\n}\n\n.orange-text {\n  background-color: var(--amarelo3);\n  text-align: center;\n  font-size: 14px;\n  color: var(--amarelo2);\n  border: 1px solid var(--amarelo2);\n  padding: 0 6px;\n  border-radius: 4px;\n}\n\n.purple-text {\n  background-color: #f2ecff;\n  text-align: center;\n  font-size: 14px;\n  color: #5a39a8;\n  border: 1px solid #7c5cc7;\n  padding: 0 6px;\n  border-radius: 4px;\n}\n\nabbr {\n  text-decoration: none;\n}\n\n\n/* Animacao */\n/* Keyframes for the enter animation (bottom to top) */\n@keyframes slideIn {\n  from {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Keyframes for the exit animation (top to bottom) */\n@keyframes slideOut {\n  from {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  to {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n}\n\n/* Base style for the section */\n.container-animation {\n  transition: opacity 0.5s ease, transform 0.5s ease;\n}\n\n/* Enter animation applied when section is displayed */\n.container-animation.show {\n  animation: slideIn 0.5s ease forwards;\n}\n\n/* Exit animation applied when section is hidden */\n.container-animation.hide {\n  animation: slideOut 0.5s ease forwards;\n}\n\n\n@media screen and (max-width: 580px) {\n  form {\n    flex-direction: column;\n  }\n}\n.page-title,\nh2.page-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--ui-text);\n  margin: 6px 0 14px;\n}\n\n.section-title,\n.h4-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--ui-primary);\n  margin: 6px 0 12px;\n}\n\n/* primeiro título da página assume estilo de page-title */\n.container h1:first-of-type,\n.container h2:first-of-type,\n.container h3:first-of-type,\n.container h4:first-of-type {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--ui-text);\n  margin: 6px 0 14px;\n}\n\n.filter-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  padding: 12px;\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  background: var(--ui-surface);\n  box-shadow: var(--ui-shadow-sm);\n}\n\n.filter-group {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.filter-actions {\n  margin-left: auto;\n  display: flex;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
